<template>
    <div ref="$scroll" class="scroll-container">
        <div ref="$sequence" class="image-sequence">
            <div v-for="item in images" ref="$medias" :key="item.id" class="page-media w-ratio">
                <UiImage :src="item.webp" :classes="'responsive'" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        images?: CmsItem[];
    }>(),
    {
        images: () => []
    }
);

const { $gsap: gsap, $ScrollTrigger: ScrollTrigger } = useNuxtApp();
const $scroll = ref<HTMLDivElement | null>(null);
const $sequence = ref<HTMLDivElement | null>(null);
const $medias = ref<HTMLElement[]>([]);
const images = computed(() => props.images);

useStartAnimations($scroll.value!, () => {
    const itemLength = images.value.length;
    const mainEl = $scroll.value?.closest('section');
    if (!$sequence.value || !itemLength) return;

    ScrollTrigger?.matchMedia({
        '(max-width: 767px)': () => {
            const itemWidth = ($sequence.value!.clientWidth / itemLength) * (itemLength - 1);
            const offset = 80;
            gsap.to($sequence.value, {
                x: -itemWidth + offset,
                ease: 'none',
                scrollTrigger: {
                    invalidateOnRefresh: true,
                    trigger: mainEl,
                    start: 'top -20%',
                    end: `+=${itemWidth - offset * 2}px`,
                    scrub: true,
                    pin: true,
                    snap: {
                        snapTo: 1 / (itemLength - 1),
                        duration: { min: 0.2, max: 0.6 },
                        ease: 'power4'
                    }
                }
            });
        },
        '(min-width: 768px)': () => {
            const sequenceHeightFull = $sequence.value!.clientHeight;
            const sequenceHeight = (sequenceHeightFull / itemLength) * (itemLength - 1);
            const itemsHeight = $medias.value.map(item => item.clientHeight).reduce((a, i) => a + i + 50, 0);
            const offset = sequenceHeightFull - itemsHeight;

            gsap.to($sequence.value, {
                y: -sequenceHeight + offset,
                ease: 'none',
                scrollTrigger: {
                    invalidateOnRefresh: true,
                    trigger: mainEl,
                    start: 'top top',
                    end: `+=${sequenceHeight - offset}px`,
                    scrub: 1,
                    pin: true,
                    snap: {
                        snapTo: 1 / (itemLength - 1),
                        duration: { min: 0.2, max: 0.6 },
                        ease: 'power4'
                    }
                }
            });
        }
    });
});
</script>
